//** Component  */
import React from "react";

//** Lib */

import SyncData from "../SyncData";
import CustomTab from "../../../components/common/RenderTab/CustomTab";
import { hasFunctionalPermission } from "../../../utils/AuthorizeNavigation/authorizeNavigation";
import { securityKey } from "../../../navigation/SecurityKey";


function SyncDataList() {

  const hasOpenTabPermission = hasFunctionalPermission(securityKey.PRODUCTDATASYNCOPENTAB);
  const hasArchiveTabPermission = hasFunctionalPermission(securityKey.RPAREQUESTARCHIVETAB);

  const data = [
    {
      id: "1",
      tabTitle: "Open",
      tabContent: <SyncData openStatus={1} />,
      isVisible: hasOpenTabPermission?.hasAccess,
    },
    {
      id: "2",
      tabTitle: "Archive",
      tabContent: <SyncData openStatus={2} />,
      isVisible: hasArchiveTabPermission?.hasAccess,
    },
  ];

  return (
    <>
      <CustomTab data={data} />
    </>
  );
}

export default SyncDataList;
